import { render, staticRenderFns } from "./MySalesHistory.vue?vue&type=template&id=d86e5c66&"
import script from "./MySalesHistory.vue?vue&type=script&lang=js&"
export * from "./MySalesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports